import { useGetPatientReportQuery } from '../api';

export const useGetPatientReportUseCase = (externalId: string) => {
  return useGetPatientReportQuery(externalId);
};
